import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { bouncy } from 'ldrs'
import { toast } from "react-toastify";
import { addDesignation, updateDesignation } from "../AttendanceApis";

bouncy.register()

const AddEditDesignations = ({
    showModal,
    setShowModal,
    handleSave,
    editRow,
    isEditMode,
    departmentData:
    operationData,
    getDesignationsData
}) => {

    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        const updatedValues = {...values, isActive: values.isActive === 'true'}
        setLoading(true);
        if (isEditMode) {
            const response = await updateDesignation({ ...updatedValues, designationId: editRow?.designationId });
            if (response.status === 200) {
                toast.success(response.data);
                handleClose();
                getDesignationsData();
            } else {
                if (response.status === 500) {
                    toast.error(response.response.data.title);
                } else {
                    toast.error(response.response.data);
                }
            }
            setLoading(false);
        } else {
            const response = await addDesignation(updatedValues);
            if (response.status === 200) {
                toast.success("Designation added successfully!");
                handleClose();
                getDesignationsData();
            } else {
                toast.error(response.response.data);
            }
            setLoading(false);
        }
    };



    const handleClose = () => {
        setShowModal(false);
    };


    const initialValues = {
        operationId: isEditMode ? editRow?.operationId : "",
        designationName: isEditMode ? editRow?.designationName : "",
        isActive: isEditMode ? editRow?.isActive.toString() : "true",
    };

    const validationSchema = Yup.object().shape({
        operationId: Yup.string().required("Operation is required"),
        designationName: Yup.string()
            .matches(/^[^\s]/, "Designation cannot start with a space.")
            .matches(/^[a-zA-Z0-9 ]*$/, "Designation cannot contain special characters.")
            .min(3, "Designation minimum contain 3 letters.")
            .required("Designation is required"),
        isActive: Yup.boolean().required("Status is required"),
    });


    return (
        <Modal
            show={showModal}
            onHide={handleClose}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {editRow ? "Edit Designation" : "Add Designation"}
                </Modal.Title>
                <i
                    className="fa-solid fa-xmark close-container"
                    onClick={handleClose}
                ></i>
            </Modal.Header>
            <hr />
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ errors, touched }) => (
                        <FormikForm>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="operationId" className="form-label"> Operation <span className="text-danger">*</span></label>
                                        <Field
                                            as="select"
                                            name="operationId"
                                            id="operationId"
                                            className="form-select"
                                        >
                                            <option value="" label="Select Operation" />
                                            {operationData?.filter((operation) => operation.isActive).map((operation) => (
                                                <option
                                                    key={operation.operationId}
                                                    value={operation.operationId}
                                                >
                                                    {operation.operationName}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage className="small" name="operationId" component="div" style={{ color: 'red' }} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="designationName" className="form-label">
                                            Designation <span className="text-danger">*</span>
                                        </label>
                                        <Field
                                            type="text"
                                            name="designationName"
                                            id="designationName"
                                            placeholder="Enter Designation"
                                            className="form-control"
                                            maxLength={50}
                                        />
                                        <ErrorMessage className="small" name="designationName" component="div" style={{ color: 'red' }} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Status<span style={{ color: "#EC1117" }}> *</span>
                                    </label>
                                    <div className="form-group" style={{ display: "flex", alignItems: 'center' }}>
                                        <div className="form-check d-flex">
                                            <Field
                                                type="radio"
                                                className="form-check-input"
                                                name="isActive"
                                                id="activeRadio"
                                                value="true"
                                            />
                                            <label className="form-check-label" htmlFor="activeRadio">
                                                Active
                                            </label>
                                        </div>
                                        <div className="form-check ms-4 d-flex">
                                            <Field
                                                type="radio"
                                                className="form-check-input"
                                                name="isActive"
                                                id="inactiveRadio"
                                                value="false"
                                            />
                                            <label className="form-check-label" htmlFor="inactiveRadio">
                                                InActive
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-end d-flex justify-content-center">
                                <button type="submit" className="deployment-button">
                                    {isEditMode ?
                                        loading ?
                                            <l-bouncy
                                                size="25"
                                                speed="1.75"
                                                color="white"
                                            ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Update</> :
                                        loading ? <l-bouncy
                                            size="25"
                                            speed="1.75"
                                            color="white"
                                        ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Submit </>}
                                </button>
                            </div>
                        </FormikForm>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default AddEditDesignations;
